import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownBlockComponent } from './components/markdown-block/markdown-block.component';
import { SharedModule } from '../shared/shared.module';
import { ImagesBlockComponent } from './components/images-block/images-block.component';
import { MaterialModule } from '../material.module';
import { ContentBlocksComponent } from './components/content-blocks/content-blocks.component';
import { TickerModule } from './components/ticker-block/ticker-block.module';
import { MarkdownBlock } from './models/markdown-block';

@NgModule({
  declarations: [
    ContentBlocksComponent,
    MarkdownBlockComponent,
    ImagesBlockComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    TickerModule
  ],
  exports: [
    ContentBlocksComponent,
    ImagesBlockComponent,
    MarkdownBlockComponent
  ]
})
export class ContentBlocksModule { }
